import { Routes, Route, Navigate } from "react-router-dom";
import { DashboardShell } from "@/components/dashboard/DashboardShell";
import { chapterHeadConfig } from "@/config/chapter-head";
import Overview from "./overview";
import Mahallu from "./community";
import Sponsorships from "./donors";
import Payments from "./history";
import Settings from "./settings";

export default function ChapterHeadDashboard() {
  return (
    <DashboardShell navItems={chapterHeadConfig.sidebarNav}>
      <Routes>
        <Route path="overview" element={<Overview />} />
        <Route path="mahallu" element={<Mahallu />} />
        <Route path="sponsorships" element={<Sponsorships />} />
        <Route path="payments" element={<Payments />} />
        <Route path="settings" element={<Settings />} />
        <Route index element={<Navigate to="overview" replace />} />
      </Routes>
    </DashboardShell>
  );
}
